(() => {
  const menu = document.getElementById('bb-ink-menu');
  const packs = document.getElementById('bb-ink-pack-dialog');
  let returnFocus;
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    document.querySelectorAll('dialog[open]').forEach(other => other.close());
    returnFocus = opener || document.activeElement;
    dialog.showModal();
  }
  [menu, packs].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-bb-offer-open], [data-bb-charity-open]')) menu?.close();
  }, true);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-bb-menu-open], [data-bb-pack-open]');
    if (opener) { event.preventDefault(); openDialog(opener.hasAttribute('data-bb-menu-open') ? menu : packs, opener); }
    event.target.closest('[data-bb-dialog-close]')?.closest('dialog')?.close();
    if (event.target.closest('#bb-ink-menu a')) menu?.close();
  });
  function openPackFromHash() {
    if (/^#bb-offer-pack-[24]$/.test(location.hash) || location.hash === '#bb-offer-packs') {
      openDialog(packs);
      packs?.querySelector(location.hash)?.querySelector('select, a, button')?.focus();
    }
  }
  window.addEventListener('hashchange', openPackFromHash);
  openPackFromHash();
  document.querySelectorAll('.bb-offer__form').forEach(form => {
    const pack = form.closest('.bb-offer__pack'), select = form.querySelector('[name="selling_plan"]'), button = form.querySelector('[type="submit"]'), error = form.querySelector('[data-bb-launch-error]');
    const submitLabel = button?.querySelector('[data-bb-launch-label]'), idleLabel = submitLabel?.textContent;
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      pack.querySelector('[data-bb-launch-price]').textContent = option.dataset.firstPrice;
      pack.querySelector('[data-bb-launch-renewal]').textContent = option.dataset.renewal;
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      button.disabled = true; form.setAttribute('aria-busy', 'true'); error.hidden = true;
      if (submitLabel) submitLabel.textContent = button.dataset.bbLoadingLabel;
      try {
        const response = await fetch(form.dataset.cartAddUrl, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if (!response.ok) throw new Error('Cart add failed');
        location.assign(form.dataset.checkoutUrl);
      } catch { error.hidden = false; button.disabled = false; form.removeAttribute('aria-busy'); if (submitLabel) submitLabel.textContent = idleLabel; }
    });
  });
  const previewId = new URLSearchParams(location.search).get('preview_theme_id') || (document.documentElement.dataset.bbThemeRole === 'unpublished' ? document.documentElement.dataset.bbThemeId : null);
  if (previewId) document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href);
    if (['branandbirdys.com','branandbirdys.ie'].includes(url.hostname) && !url.pathname.startsWith('/discount/')) {url.searchParams.set('preview_theme_id', previewId);link.href=url.href;}
  });
})();
